var map = {
	"./tapcoin/new/avatar/index-bg-basic.jpg": 24435,
	"./tapcoin/new/avatar/index-bg-basic1.jpg": 8801,
	"./tapcoin/new/avatar/index-bg-basic2.jpg": 26331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12835;